export const pageFlag = {
  detail: 'detail',
  edit: 'edit',
  list: 'list',
}

/**
 * 发送方出库状态
 */
export const sendOutBound = {
  val: 'no',
  na: {
    name: '无仓库系统',
    val: 'na',
  },
  no: {
    name: '无出库',
    val: 'no',
  },
  yes: {
    name: '有出库',
    val: 'yes',
  },
}

/**
 * 发送方状态
 */
export const sendStatus = {
  val: 'review',
  review: {
    name: '待审核',
    val: 'review',
  },
  reviewed: {
    name: '已审核',
    val: 'reviewed',
  },
  closed: {
    name: '已关闭',
    val: 'closed',
  },
  cancel: {

    name: '已取消',
    val: 'cancel',
  }
}

/**
 * 发送方协同状态
 */
export const sendXtStatus = {
  val: 'uncooperative',
  uncooperative: {
    name: '空状态',
    val: 'uncooperative',
    pageFlag: 'detail',
  },
  receiving: {
    name: '待对方收货',
    val: 'receiving',
    pageFlag: 'detail',
  },
  receivingException: {
    name: '待本方接受收货异常',
    val: 'receivingException',
    pageFlag: 'detail',
  },
  receivingConfirmException: {
    name: '待本方确认收货异常',
    val: 'receivingConfirmException',
    pageFlag: 'detail',
  },
  receivingRejectionException: {
    name: '本方拒绝收货异常',
    val: 'receivingRejectionException',
    pageFlag: 'detail',
  },
  complete: {
    name: '已完成',
    val: 'complete',
    pageFlag: 'detail',
  },
  refuse: {
    name: '对方已拒收',
    val: 'refuse',
    pageFlag: 'detail',
  },
  cancel: {
    name: '已取消',
    val: 'cancel',
    pageFlag: 'detail',
  }
}

/**
 * 收方入库状态
 */
export const receiveInBound = {
  val: 'no',
  na: {
    name: '无仓库系统',
    val: 'na',
  },
  no: {
    name: '无入库',
    val: 'no',
  },
  yes: {
    name: '有入库',
    val: 'yes',
  },
}

/**
 * 收方状态
 */
export const receiveStatus = {
  val: 'empty',
  empty: {
    name: '空状态',
    val: 'empty',
  },
  review: {
    name: '待审核',
    val: 'review',
  },
  reviewed: {
    name: '已审核',
    val: 'reviewed',
  },
  closed: {
    name: '已关闭',
    val: 'closed',
  },
  cancel: {
    name: '已取消',
    val: 'cancel',
  }
}

/**
 * 收方协同状态
 */
export const receiveXtStatus = {
  val: 'uncooperative',
  // uncooperative: {
  //   name: '未协同',
  //   val: 'uncooperative',
  // },
  receiving: {
    name: '待本方收货',
    val: 'receiving',
    pageFlag: 'detail',
  },
  receivingException: {
    name: '待对方接受收货异常',
    val: 'receivingException',
    pageFlag: 'detail',
  },
  receivingRejectionException: {
    name: '对方拒绝收货异常',
    val: 'receivingRejectionException',
    pageFlag: 'detail',
  },
  confirmReceiving: {
    name: '待本方确认收货',
    val: 'confirmReceiving',
    pageFlag: 'detail',
  },
  complete: {
    name: '已完成',
    val: 'complete',
    pageFlag: 'detail',
  },
  refuse: {
    name: '本方已拒收',
    val: 'refuse',
    pageFlag: 'detail',
  },
  cancel: {
    name: '已取消',
    val: 'cancel',
    pageFlag: 'detail',
  }
}



// WEBPACK FOOTER //
// ./src/data/statusData.js